<template>
  <div>
    <div class="flex p-5 items-center">
      <div>
        <div
          class="w-12 ml-5 h-12 rounded-full bg-blue-400 flex items-center justify-center"
        >
          <v-icon color="white" size="30">mdi-account</v-icon>
        </div>
      </div>
      <h1 class="text-center text-xl font-bold  ">ثبت نام کاربر عادی</h1>
    </div>
    <div class="p-5 mt-0">
      <v-form ref="userForm" v-if="!codeBox" v-model="userForm">
        <v-row>
          <v-col cols="6" class="pb-0">
            <v-text-field
              :rules="[rules.required]"
              v-model="managerName"
              variant="outlined"
              outlined
              color="info"
              label="نام"
            ></v-text-field>
          </v-col>
          <v-col cols="6" class="pb-0">
            <v-text-field
              :rules="[rules.required]"
              v-model="managerFamily"
              outlined
              color="info"
              label="نام خوانوادگی"
            ></v-text-field>
          </v-col>
          <v-col cols="6" class="pb-0">
            <v-text-field
              :rules="[rules.required, rules.numberic]"
              v-model="nationalId"
              outlined
              color="info"
              label="کد ملی"
            ></v-text-field>
          </v-col>
          <v-col cols="6" class="pb-0">
            <v-text-field
              :rules="[rules.required, rules.numberic]"
              v-model="mobile"
              outlined
              color="info"
              label="شماره موبایل"
            ></v-text-field>
          </v-col>
          <v-col cols="6" class="pb-0">
            <v-autocomplete
              :items="provinces"
              v-model="provinceId"
              :rules="[rules.required]"
              outlined
              color="info"
              item-value="id"
              item-text="title"
              label="یک استان را انتخاب کنید"
            ></v-autocomplete>
          </v-col>
          <v-col cols="6" class="pb-0">
            <v-autocomplete
              :items="city"
              v-model="cityId"
              color="info"
              outlined
              :rules="[rules.required]"
              item-value="id"
              item-text="title"
              :disabled="provinceId === ''"
              label="یک شهر را انتخاب کنید"
            ></v-autocomplete>
          </v-col>
          <v-col cols="6" class="pb-0">
            <v-text-field
              class="birthDate"
              v-model="birthDate"
              outlined
              color="info"
              label="تاریخ تولد"
            ></v-text-field>
            <date-picker
              custom-input=".birthDate"
              simple
              max="1385/00/00"
              v-model="birthDate"
            ></date-picker>
          </v-col>
        </v-row>
        <div class="flex items-center">
          <v-checkbox
            :rules="[rules.required]"
            v-model="rule2"
            hide-details
            class="ml-2"
          />
          <span>
            <button
              type="button"
              @click="dialog2 = true"
              class="text-blue-500 hover:border-b border-blue-500"
            >
              قوانین و مقررات
            </button>
            را مطالعه کردم و با آن موافقم
          </span>
        </div>
        <div class="flex items-center">
          <v-checkbox
            :rules="[rules.required]"
            v-model="rule1"
            hide-details
            class="ml-2"
          />
          <span>
            <button
              type="button"
              @click="dialog1 = true"
              class="text-blue-500 hover:border-b border-blue-500"
            >
              قوانین پرداخت خسارت
            </button>
            را مطالعه کردم و با آن موافقم
          </span>
        </div>
        <v-btn
          :loading="loading"
          @click="sendOtp"
          color="info"
          block
          large
          class="mt-10"
          >ارسال پیامک</v-btn
        >
      </v-form>
      <v-form v-else>
        <v-row>
          <v-col cols="12">
            <v-text-field
              :rules="[rules.required, rules.numberic]"
              v-model="otp"
              outlined
              color="info"
              :label="`کد ارسال شده به شماره ${mobile} را وارد کنید`"
            ></v-text-field>
          </v-col>
          <button
            type="button"
            @click="(codeBox = false), (otp = '')"
            class="mt-1 text-sm text-blue-500 flex items-center"
          >
            <v-icon size="20" color="info">mdi-arrow-right</v-icon>
            شماره را اشتباه وارد کردم
          </button>
          <g-recaptcha
            data-sitekey="6LeQCbsoAAAAAPjBvHvAtb5OqVtg7AzBav4YrF5K"
            :data-validate="validate"
            :data-callback="callback"
          >
            <v-btn :loading="loading" color="info" block large class="mt-5"
              >ثبت نام</v-btn
            >
          </g-recaptcha>
        </v-row>
      </v-form>
    </div>
    <v-dialog v-model="dialog1" width="500">
      <v-card>
        <div class="text-xl grey lighten-2 p-5">قوانین پرداخت خسارت</div>
        <v-card-text class="mt-5">
          <p class="whitespace-pre-line">
            با توجه به اینکه بارگرام یک سامانه پایانه بار مجازی است و اعلام
            بارها توسط کاربران صورت می گیرد و بارگرام تمام تلاش خود را برای
            ایجاد اعلام بار های مطمئن بکار گرفته است و همچنین از رانندگان با صحت
            سنجی بالا و مطمئن در سیستم استفاده می کند.بارگرام در صورتی که به
            هریک از دلایل زیر به هر یک از طرفین خسارتی وارد گردد را جبران می
            نماید. موارد مربوط به تاخیر در بارگیری و تخلیه بار طبق قوانین
            بارگرام در صورتی که تاخیر چه در مرحله بارگیری و چه در مرحله تخلیه
            بار بیشتر از ۱۲ ساعت باشد ، راننده می تواند در صورت تمایل و با توجه
            به پس کرایه بودن بارنامه به ازای هر ساعت مبلغ تعیین شده در تعرفه حق
            توقف را از کاربران دریافت نماید. تذکر :در صورتی که توافقی خارج از
            ضوابط حاکم بر حمل و نقل صورت پذیرد، بارگرام بر توافق فوق بین راننده
            و تحویل صاحبان کالا هیچ دخالت ، دخل و تصرفی نداشته و نخواهد داشت و
            ضمناً دریافت کمتر یا بیشتر از مبلغ فوق جز توافق به حساب می آید.
            موارد مربوط به اضافه بار در صورتی که بعد از اتمام بارگیری ، تناژ بار
            اعلامی در سامانه اعلام بار بارگرام مغایرت بیش از 500 کیلو داشت ، در
            صورت تمایل و توافق راننده می تواند به ازای هر تن اضافه مبلغ (کرایه /
            22) ریال از صاحب بار مطالبه و در صورت عدم توافق راننده هیج وظیفه ای
            در قبال حمل محموله صاحب بار نداشته و ندارد و صاحب کالا بایستی خسارت
            راننده را پرداخت نماید. تذکر : بارگرام در توافق مالی بین راننده و
            صاحب بار و یا تحویل گیرنده بار هیچ دخالت ، دخل و تصرفی نداشته و
            نخواهد داشت . ضمناً دریافت کمتر یا بیشتر از مبالغ فوق جز همان توافق
            بحساب می آید. موارد مربوط به کنسل کردن حواله الف ) چنانچه اعلام باری
            که توسط کاربران ایجاد و تبدیل به حواله شده است(یعنی برای اعلام بار
            راننده تخصیص داده شده است) توسط کاربران (صاحبان کالا-واحد صنفی –
            شرکت حمل و نقل) باطل گردد.و چنانچه مشخص گردد راننده قبل از ابطال
            ترددی به سمت محل بارگیری داشته است بایستی به ازای هر کیلومتر مبلغ
            000/400 ریال به راننده خسارت پرداخت نماید. این خسارت از کیف پول
            کاربر کسر و در صورت کافی نبودن موجودی این مبلغ از روش های دیگر از
            کارببران و صاحبان کالا وصول می گرد. ب ) چنانچه راننده اقدام به باطل
            کردن حواله ای نماید به نحوی که برای آن اعلام بار رزرو دیگر وجود
            نداشته باشد و این امر سبب تاخیر در ارسال کالای صاحب کالا گردد راننده
            10 نمره منفی و مبلغ 000/000/3 ریال جریمه نقدی میگردد. این مبلغ از
            کیف پول راننده کسر وبه کیف پول صاحب کالا افزوده می شود. ج) چنانچه
            راننده به نمره منفی 50 برسد از استفاده خدمات سامانه بمدت 3 ماه و
            چنانچه نمره منفی راننده به عدد 100 برسد 6 ماه و چنانچه نمره منفی به
            عدد 150 برسد بمدت یکسال محروم می شود. موارد مربوط به ابطال بارنامه
            الف ) صاحبان باری که پس از بارگیری و صدور بارنامه درخواست ابطال
            حواله را نماید. بایستی خسارت راننده را طبق توافق و یا یک کرایه حمل
            شهری مطابق با تعرفه سازمان راهداری و حمل و نقل جاده ای به راننده
            پرداخت نماید و هزینه های بارنامه را نیز به شرکت حمل و نقل پرداخت
            کند. چنانچه مبلغ خسارت در کیف پول صاحب کالا موجود نباشد بارگرام می
            تواند آن را از طرق دیگر وصول نماید. .
          </p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="(dialog1 = false), (rule1 = true)"
          >
            میپذیرم
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog2" width="500">
      <v-card>
        <div class="text-xl grey lighten-2 p-5">قوانین و مقررات</div>
        <v-card-text class="mt-5">
          <p class="whitespace-pre-line">
            ماده ۱- تعاریف و اصطلاحات اصطلاحاتی که در این قوانین و مقررات به کار
            رفته است دارای معانی زیر است : 1- 1 صاحب کالا : شخص حقیقی یا حقوقی
            که در سامانه بارگرام ثبت نام کرده و اقدام به اعلام بار می کند. این
            شخص می تواند در نقش فرستنده بار و یا گیرنده بار و یا هر دو از سامانه
            استفاده نماید. 1-2 واحد صنفی : شخص حقوقی و یا یک واحد صنعتی است که
            در سامانه بارگرام ثبت نام می کند و اقدام به افزودن شرکت حمل و نقل
            برای صدور بارنامه کرده و اعلام بار ثبت می کند. ۳-۱:رانندگان: افراد
            داراری کارت هوشمند فعال که در اپلیکیشن راننده در سامانه بارگرام بطور
            کامل ثبت نام کرده و با افزودن ناوگان دارای کارت هوشمند فعال با گرفتن
            نوبت و رزرو بار درخواست حمل بار از فهرست بارهای بارگرام را دارند.
            4-۱:کاربر: همان صاحب کالا، واحد صنفی، شرکت حمل و نقل و شخصی حقیقی و
            حقوقی است که با فناوری ارتباطی و به وسیله اینترنت به اپلیکیشن و سایت
            بارگرام متصل و از خدمات نرم افزاری بارگرام بهره مند می گردد و برای
            جذب ناوگان اعلام بار می نماید . 5-۱:شرکت های حمل و نقل: شرکتهای حمل
            و نقل دارای مجوز از سازمان راهداری و حمل و نقل که برای اعلام بار
            وصدور بارنامه برای واحد های صنفی در سامانه بارگرام ثبت نام می کنند.
            6-۱: اعلام بار: درخواست حمل و نقل یک محموله از یک مبدا به یک مقصد که
            توسط کاربران اعلام می شود که با نمایش در سالن های اعلام بار بارگرام
            رانندگان آن را رزرو می کنند.. 1-7 حواله: مجوزی است که نسبت به تعداد
            ناوگانی که در اعلام بار مشخص شده است برای یک راننده و ناوگان برای
            مبدا و مقصدی که کاربران در اعلام بار مشخص کرده اند صادر می گردد.
            7-۱: شرکت شایان پردازش مهرگستر رسا: مالک و مجری سامانه بارگرام .
            8-۱: بارگرام: سامانه هوشمند بازارگاه الکترونیکی حمل و نقل کالا و
            پایانه بار مجازی است که توسط شرکت شایان پردازش توسعه یافته است .
            9-۱: حساب کاربری: حسابی است که برای استفاده از سامانه در سایت و نرم
            افزار بارگرام با رمز و نام کاربری خودشان ایجاد می نمایند. 10-۱ :حریم
            شخصی: اطلاعاتی که توسط کلیه کاربران سامانه بارگرام از جمله صاحبان
            بار، رانندگان و شرکت های حمل و نقلی در اختیار بارگرام قرار داده می
            شود مانند مشخصات کارت های هویتی، کارتهای هوشمند حرفه ای، مجوزهای
            مختلف، شمارهای تماس، اقامتگاه، پست الکترونیکی و بطور کلی کلیه مدارک
            و مستنداتی که در زمان ثبت نام در سامانه بارگرام از ایشان اخذ و دیتای
            آن در سرور بارگرام ذخیره می گردد . ماده ۲ – حساب کاربری ۱-۲:کاربر با
            ثبت نام در بارگرام می پذیرد که قوانین و مقررات و طریقه ی استفاده از
            بارگرام را به صورت کامل مطالعه کرده و قبول کرده است این قوانین ممکن
            است در طول زمان تغییر و تکمیل گردد، استفادۀ مستمر کلیه ی کاربران از
            بارگرام به معنی پذیرش هرگونه تغییر در قوانین و مقررات آن است .
            ۲-۲:برای استفاده از بارگرام لازم است که هر کاربر یک حساب کاربری در
            سامانه بارگرام بسازد، تنها افرادی که واجد اهلیت قانونی باشند می
            توانند اقدام به ساختن حساب کاربری در بارگرام کنند. برای استفاده از
            بارگرام کاربر می بایست کلیه مشخصات لازم که در فرمهای ثبت نامی وجود
            دارد را به درستی و با صحت کامل تکمیل نماید مادامی که سامانه بارگرام
            مشخصات ثبت نامی کاربران را با کسب اطلاع از مراجع قانونی تایید صحت
            ننموده، کاربر ثبت نام رسمی نگردیده است و ثبت نام ایشان موقت به شمار
            می آید. ۳-۲: کاربر قبول می کند اطلاعات خواسته شده را پس از ثبت نام
            رسمی نیز در مقاطع هشدار سامانه به روز رسانی نماید تا امکان استفاده
            از سامانه برای ایشان در آینده با مشکل مواجه نگردد. ۴-۲:هر شخص حقیقی
            تنها می تواند یک حساب کاربری به عنوان صاحب کالا یا راننده در بارگرام
            داشته باشد. واحد صنفی و شرکت حمل و نقل می توانند در سیستم کاربر
            اضافه نمایند. ۵-۲:مسئولیت همۀ فعالیت هایی که از طریق حساب کاربری
            اشخاص در بارگرام یا سایر خدمات مربوط به بارگرام انجام می شود به عهدۀ
            کاربر مربوطه است . ۶-۲: مسئولیت حفظ امنیت اطلاعات حساب کاربری از
            جمله نام کاربری و رمز عبور به عهدۀ کاربر است. 2-7: رانندگان قبول می
            کنند که موبایلی که اپلیکیشن بر آن نصب شده باشد تا مقصد همراعه داشته
            باشند و برای ثبت لحظه ای مکان را روشن نگه دارند. 2-8: در صورت مفقود
            شدن یا سرقت اطلاعات حساب کاربری، کاربر موظف است در اسرع وقت موضوع را
            به مرکز پشتیبانی بارگرام اطلاع دهد. بدیهی است تا زمانی که اطلاع
            رسانی به شرکت انجام نشده است مسئولیت همۀ فعالیت هایی که از طریق حساب
            کاربری مذکور انجام شده و می شود همچنان به عهدۀ کاربر خواهد بود. 2-9:
            با توجه به منحصر به فرد بودن شماره های تلفن همراه در سامانه بارگرام،
            کاربران موظف هستند شماره موبایل بنام خود را مورد استفاده قرار دهند و
            در صورت هر گونه تغییر در شماره اعلامی به سامانه بارگرام حساس بوده و
            مرکز پشتیبانی بارگرام را مطلع سازید. این موضوع به ویژه در مورد
            رانندگان بارگرام بسیار مهم می باشد زیرا تصدیق اصالت راننده و صدور
            بارنامه بارگرام صرفا از طریق تلفن همراه شخص راننده اتفاق می افتد.
            9-۲: کاربر حق ندارد به اشخاص حقیقی و حقوقی دیگر اجازه استفاده از
            حساب کاربری خود را بدهد یا حساب خود را به فرد یا شرکت دیگری منتقل
            کند .10-۲: در شرایط خاصی ممکن است سامانه بارگرام به دلیل شکایت
            مشتریان و یا باطل و توقیف کردن مدارک توسط مراجع قانونی حساب کاربری
            کاربر را مسدود نماید و از ارائه خدمات به ایشان خودداری کند؛ بارگرام
            این حق را تا آخر برای خود محفوظ می داند. ماده ۳ – استفاده از بارگرام
            3-1 راننده متعهد است با توجه به صحت سنجی اطلاعات با سامانه راهداری
            از استفاده اطلاعات سایرین برای ورود و یا ناوگان دیگر استفاده نکند.
            ۲-۳: با استفاده از سامانه بارگرام کاربر می پذیرد که از این سامانه
            برای انجام هیچ فعالیت غیرقانونی طبق قوانین جمهوری اسلامی ایران یا
            مخالف با عرف جامعه استفاده نکند. کاربر حق ندارد موارد غیر مجاز از
            جمله مشروبات الکلی، مواد مخدر، سلاح یا سایر اشیاء یا حیواناتی که طبق
            قوانین جاری جمهوری اسلامی ایران مجاز نیست از طریق این سامانه اعلام
            بار نموده یا حتی همراه خود داشته باشد . ۳-۳:صاحب بار متعهد است در
            صورت داشتن اعلام بار نامتعارف، اعم از هر گونه پرنده یا حیوانات دیگر،
            دام زنده، مواد خطرناک، مواد اسیدی و یا هر موردی از این قبیل موضوع را
            از قبل به مرکز پشتیبانی اعلام نماید؛ در غیر این صورت چنانچه راننده
            پس از پذیرش بار و عزیمت به نقطه مبدا، با موارد فوق مواجه شود، مجاز
            به لغو و امتناع از انجام حمل بوده و مسئولیت جبران خسارات مالی وارده
            برعهدۀ کاربر صاحب بار می باشد. ۴-۳:کاربر متعهد می شود هیچگاه از
            سرویس بارگرام به صورتی که به بارگرام و برند بارگرام صدمه ای وارد کند
            اقدامی صورت ندهد. ۵-۳:کاربر می پذیرد که بارگرام از ارسال پیامک به
            عنوان یک راه ارتباطی برای اطلاع رسانی همزمان یا زمانی که کاربر به
            اینترنت متصل نیست استفاده نماید و حتی اگر کاربر بارگرام در لیست سیاه
            پیامک های تبلیغاتی اپراتورهای تلفن همراه باشد از سرشماره سامانه
            بارگرام پیامک دریافت کند. ۸-۳:کاربر می پذیرد که در شماره حساب وارد
            شده در پروفایل کاربری خود بعنوان شماره حساب فعال آن است و بارگرام در
            روزهای دوشنبه و چهارشنبه هر هفته مطالبات فاکتورهای عملکردی و کرایه
            ها را در مدت کارکرد را به حسابهای اعلامی واریز نماید. ۹-۳:مسئولیت
            تامین اینترنت و سخت افزار لازم و همچنین پرداخت هزینه های مربوط به
            آنها برای استفاده از سامانه بارگرام به عهدۀ کاربران می باشد. ۱۰-۳
            :کاربران می پذیرند حداکثر بار مجاز در هر ماشین همان است که در کارت
            ماشین نوشته شده و زدن اضافه بار به هیچ وجه حتی با توافق صاحب بار و
            راننده مجاز نمی باشد و بارگرام عواقب تخطی از این قانون را نمی پذیرد
            و در صورت بروز مشکل حساب کاربری کاربران را مسدود می نماید. 3-11:
            راننده تعهد می کند در صورت صدور حواله حتما برای حمل بار اقدام نماید
            و در صورت تخطی از این موضوع بارگرام می تواند راننده را جریمه نقدی
            نماید. 3-12 سامانه بارگرام هیچ تضمینی برای پیدا کردن بار برای
            رانندگانی که نوبت گرفته اند ندارد. ۱۱-۳ :کاربر متعهد می شود پس از
            اتمام حمل از هیچ بخش از اطلاعاتی که در نتیجه استفاده از سامانه
            بارگرام، از صاحبان بار و یا حتی رانندگان کسب کرده است هیچگونه سوء
            استفاده ای نکند. طبعاً ذخیره کردن اطلاعات صاحبان بار و یا رانندگان
            در دستگاه تلفن همراه یا به هر شیوۀ دیگر نیز مغایر با قوانین و اخلاق
            حرفه ای در بارگرام خواهد بود. ۱۳-۳ :کاربران متعهد به رعایت همۀ
            قوانین راهنمایی و رانندگی، اسلامی، شرعی، اخلاقی و اجتماعی جمهوری
            اسلامی ایران هنگام استفاده از بارگرام می باشند. ۱۴-۳:کاربران پذیرفته
            اند که متن حریم شخصی بارگرام را مطالعه کرده اند و مورد قبول ایشان
            قرار گرفته است . ۱۵-۳:کاربران بر این موضوع مشرف اند که بارگرام شرکت
            حمل و نقل بار نیست بلکه تنها یک خدمت نرم افزاری است که ارتباط بین
            صاحبان بار و رانندگان و شرکت های حمل و نقلی را جهت توافق بر انجام یک
            حمل فراهم می کند. در سامانه بارگرام راننده مختار است یک سفارش حمل را
            بپذیرد یا از ابتدا قبول ننماید، همچنین صاحب بار مختار است پس از
            اعلام بار خود در لیست بارهای بارگرام تا پذیرش بار توسط راننده و قبل
            از حرکت به سمت مبدا بارگیری اعلام بار خود در سامانه را لغو نماید،
            ولی درصورتی که از هر دو طرف سامانه یعنی صاحب بار و رانندگان پذیرش ها
            در سامانه نهایی گردد هر دو طرف ملزم به انجام تعهدات می باشند و پذیرش
            ایشان در سامانه برمبنای تفاهم غیر حضوری تلقی می گردد که قصور در
            انجام تعهدات مستوجب جبران خسارت در نظر گرفته شده توسط بارگرام می
            باشد. ۱۶-۳:استفاده از تلفن همراه در هنگام حرکت وسیله نقلیه و کار با
            اپلیکیشن بارگرام ممنوع می باشد. شما قرارداد با ما را با توجه به این
            ریسک و به عهده گرفتن مسئولیت استفاده ایمن از تلفن همراه پذیرفته اید.
            ماده ۴ – هزینه ها و پرداخت ۱-۴:کاربران می پذیرند هزینه های سامانه
            بارگرام منجمله هزینه نوبت و کرایه به علت شفافیت درج در سامانه پس از
            تایید یا پذیرش قابل قبول ۱۰۰ درصدی کاربران می باشد که این بر مبنای
            توافقی بودن کرایه در حوزه حمل و نقل جاده ای استوار است و بنابراین پس
            از استفاده از سامانه بارگرام اعتراضی نسبت به هزینه ی سامانه نمی
            توانند داشته باشند. سایر هزینه های احتمالی بخاطر شرایط پیش بینی نشده
            مانند اضافه بار، تاخیر در بارگیری و تخلیه بر اساس آیین نامه دریافت
            خسارات موجود در قوانین و مقررات بارگرام بر عهده شخص راننده و صاحب
            بار می باشد. ۲-۴:پرداخت هزینه مشخص شده برای صاحبان بار و رانندگان
            توسط کیف پول تعریف گردیده است و کلیه هزینه ها و جرایم از کیف پول
            برداشت می شود. کیف پول به دو روش آنلاین و انتقال کارت به کارت شارژ
            می گردد. ۳-۴:کاربر می پذیرد هزینه سرویس ارائه شده ممکن است بسته به
            ویژگی های سرویس ارائه شده از جمله نوع سرویس، زمان سرویس، مکان سرویس
            مبدا، مقصد یا مسیر حمل ( یا عوامل دیگر ) متغیر باشد . ۴-۴ : کاربران
            می پذیرند که هزینه های مشخص شده اعم از کمیسیون صدور بارنامه و پرداخت
            پیش کرایه بار ثبتی و یا حتی خسارات مالی مورد تفاهم را مستقل از هر
            گونه مشکلی که ممکن است در برنامه بارگرام جهت پرداخت آنلاین به وجود
            بیاید به شرکت پرداخت کنند. در صورتی که به دلیل مشکلی در برنامه
            بارگرام یا مشکلات ارتباطی از جمله اینترنت و شبکه تلفن همراه امکان
            پرداخت از طریق اپلیکیشن فراهم نشود کاربران همچنان موظف به پرداخت
            هزینه حمل خواهند بود. در این شرایط پرداخت هزینه ممکن است به درخواست
            شرکت بارگرام یا کاربران با روش های دیگر صورت پذیرد یا شرکت شایان
            پردزاش حق دارد مبلغ مذکور را از اعتبار کاربر در بارگرام کسر کند .
            ۶-۴: کاربران می پذیرند هر گونه آسیب به خودروی راننده در حین استفاده
            از سامانه بارگرام با حساب کاربری وی ایجاد شود اعم از توقیف خودرو در
            نتیجه مسروقه یا مشکوک بودن بار یا عدم استفاده از وسایل ایمنی و عدم
            رعایت قوانین راهنمایی و رانندگی، انفجار خود به خودی بار و از این
            قبیل اتفاقات مسئولیت تامین هزینه های مربوطه به عهده وی خواهد بود. در
            چنین مواردی بارگرام حق دارد این هزینه ها را از اعتبار کاربران کسر یا
            از وی بصورت نقدی وصول کند . ۷-۴:راننده می پذیرد هرگونه جریمه ناشی از
            تخلف از مقررات راهنمایی و رانندگی بر عهده وی بوده و کاربران مسئولیتی
            در این زمینه ندارد. همچنین هرگونه ضرر و زیان به صاحب بار (فرستنده
            بار) که به دلیل کوتاهی یا بی توجهی راننده به اصول حرفه ای یا قوانین
            راهنمایی و رانندگی باشد، باید از طریق راننده جبران شود. (این موارد
            شامل تاخیر بدون علت موجه، توقیف در نتیجه تخلف راننده، آسیب به بار در
            نتیجه مهار بار نامناسب راننده و غیره می باشد.) ۸-۴:راننده می پذیرد
            در خصوص دریافت وجه نقد از تحویل گیرنده بار بابت پرداخت هزینه کرایه
            های پس کرایه، خود مسئول وصول کرایه بارنامه خویش است و بارگرام
            مسئولیتی در این زمینه ندارد. در خصوص بارهای پیش کرایه که بصورت
            اعتباری از جانب کاربران توسط درگاه الکترونیکی پرداخت گردیده بارگرام
            در روزهای دوشنبه و چهارشنبه ی هر هفته کرایه مربوطه را به حساب راننده
            واریز می نماید. ۹-۴ :رانندگان و کاربران (فرستندگان بار و گیرندگان
            بار و واحد های صنفی) موظف هستند طبق قوانین سازمان پایانه ها و مصوبات
            یکصد و پنجاه و چهارمین شورای عالی هماهنگی ترابری کشور، مواد و تبصره
            های ذیل را رعایت نمایند. 1-9-4: هزینه پایانه‌های عمومی شامل پارکینگ،
            برگ نوبت‌دهی و حواله بارگیری و تمدید و تجدید آن بر عهده راننده یا
            مالک کامیون بوده و پرداخت هزینه‌های مربوط به عوارض شهرداری، هلال
            احمر و غیره و همچنین هزینه‌های مربوط به دیماند، باسکول، جرثقیل،
            لیفتراک و تخلیه و بارگیری و غیره مربوط به صاحب کالاست و در هر صورت
            شرکت یا مؤسسه حمل و نقل موظف به تأمین و یا وصول و ذکر آن در بارنامه
            و عنداللزوم پرداخت آن به مراجع مربوطه می‌باشد. دریافت هر گونه وجهی
            تحت عناوین پشت بارنامه، بارچینی، دالانداری انعام، گاراژداری،
            انبارداری از جانب مؤسسات و شرکتهای حمل و نقل و همچنین رانندگان ممنوع
            است. 2-9-4 : مبنای پرداخت حق توقف همیشه توافق طرفین (صاحب بار و
            راننده) می‌باشد و بارگرام در این توافق هیچ نقش و مسئولیتی بر عهده
            ندارد. 3-9-4: هر گاه کامیون پس از صدور حواله بارگیری توسط سامانه
            بارگرام، بعلت عدم وجود امکانات صاحب کالا و یا به هر علت دیگری که
            راننده مقصر نباشد، بیش از ۱۲ ساعت برای بارگیری معطل بماند، صاحب کالا
            موظف است به ازاء هر ساعت مازاد بر ۱۲ ساعت اولیه حق توقف بارگیری به
            راننده یا مالک کامیون پرداخت نماید. 5-9-4: هر گاه کامیون پس از رسیدن
            به محل تخلیه بار و به علت عدم امکانات صاحب کالا یا نماینده او و یا
            به هر علتی که راننده مقصر نباشد بیش از ۱۲ ساعت برای تخلیه معطل بماند
            شرکت یا مؤسسه حمل و نقل صادر کننده بارنامه موظف است ترتیبی اتخاذ
            نماید تا به ازاء هر ساعت مازاد بر ۱۲ ساعت اولیه به راننده یا مالک
            کامیون در مقصد تخلیه بار حق توقف پرداخت گردد. ۱۴-۴: کاربران باید
            بارهای وسائط نقلیه را طوری بارگیری و محکم ببندند که هیچگونه خطر
            افتادن یا چکه کردن یا باز شدن ویا پخش شدن در هوا وجود نداشته باشد.
            ۱۵-۴: رانندگان موظفند به دستور مأموران صلاحیتدار وسیله نقلیه را جهت
            توزین بروی قپان ببرند هر گاه ضمن توزین معلوم شود که بیش از ظرفیت
            مقرر بارگیری شده بار اضافی تخلیه می‌شود. در این صورت مسئولیت انبار
            کردن و حفظ آن به عهده صاحب بار و راننده است و بارگرام هیچ مسئولیتی
            در این موضوع نمی پذیرد. اساس دستورالعمل دریافت خسارات در مورد اضافه
            تناژ بر مبنای توافق راننده و صاحب بار می باشد. ماده ۵ – مسئولیت
            بارگرام ۱-۵: بارگرام با امکانات و خدمات خود از جمله واحدهای خدمات
            پشتیبانی مشتریان (مرکز تماس) تمام سعی خود را در رفع نیاز و رضایتمندی
            کلیه کاربران می نماید. 5-2: بارگرام تضمین می نماید که در تبدیل کردن
            رزرو ها به حواله تنها نوبت را ملاک قراردهد. و رانندگان با توجه به
            نزدیک بودن به محل بارگیری مجوز رزرو را برای رانندگان فراهم آورد.
            ۲-۵:بارگرام با استفاده از نظارت های خود، تلاش می کند خدماتی با کیفیت
            به کاربرانی که از سامانه بارگرام بهره می جویند ارائه دهد و با
            راهکارهای کیفیت محور همچون جوایز و مشوق ها، کاربران و رانندگان خود
            را به سمت ارائه خدمات با کیفیت بیشتر راهنمایی و ترغیب نماید.
            ۳-۵:بارگرام متعهد به ارائه بارنامه برای اعلام بارهای تبدیل به حواله
            شده توسط شرکتهای حمل و نقل طرف قرارداد می باشد. ۴-۵:تمامی اطلاعات
            کاربران به عنوان اطلاعات محرمانه نزد بارگرام محافظت شده و دسترسی به
            آن توسط اشخاص ثالث ممنوع بوده مگر برابر تصمیم مقام صالح قضایی.
            ۵-۵:چنانچه هر یک از کاربران بارگرام در زمان استفاده از خدمات آن با
            مشکلی مواجه شوند، می توانند شکایت خود را از طریق واحدهای تیکتینگ
            -خدمات پشتیبانی مرکز تماس بارگرام - صدای مشتریان بارگرام مطرح کنند و
            بارگرام پیگیری لازم و تلاش خود را جهت حل و فصل اختلافات به عمل خواهد
            آورد . ۷-۵: در حالی که هر گونه تلاش برای اطمینان از اینکه اطلاعات
            موجود در این سایت در زمان ارسال صحیح و به روز است، بارگرام مسئولیتی
            در قبال خسارت های ناشی از استفاده از اطلاعات موجود را ندارد و
            درصورتی که اطلاعاتی اشتباه یا خراب شده در سایت مشاهده کردید لطفا به
            ما اطلاع دهید. ۱۰-۵:بارگرام هیچگونه تضمینی برای صحت محتوای اطلاعاتی
            را که خود شما می دهید و نیز مسئولیت در قبال اشتباهات و یا نادیده
            گرفتن چنین محتوایی را نمی پذیرد و همچنین خسارات ناشی از ویروس های
            اینترنتی که ممکن است داده های غلط را نشان بدهد نیز به عهده نمی گیرد.
            ۱۱-۵: شماره تلفن های اعلامی شما کاربران گرامی منحصر به خودتان می
            باشد و بارگرام این شماره تلفن شما را مبنای تشخیص اصالت و ارتباط با
            شما می داند. ماده ۶ – مسئولیت کاربران و رانندگان ۱-۶: مسئولیت همۀ
            اقدامات و افعال کاربران فرستنده بار و راننده که ناشی از عدم رعایت
            قوانین موضوعه جمهوری اسلامی ایران از جمله قانون مجازات اسلامی
            (ارتکاب جرم در هنگام حمل) و قوانین مدنی وارد شدن خسارت به اموال صاحب
            بار باشد، برعهدۀ شخص راننده بوده و بارگرام هیچ گونه مسئولیتی در قبال
            اعمال و افعال فوق نداشته و نخواهد داشت همچنین بارگرام می تواند ضمن
            غیر فعال کردن حساب کاربری راننده متخلف در سامانه خود، از طریق مراجع
            صالح اقدامات قانونی را علیه نامبرده نسبت به احقاق حقوق قانونی خود به
            عمل آورد . ۲-۶: هر گونه اقدامی از سوی کاربران که منجر به وارد شدن
            خسارت به شهرت تجاری، نام و اعتبار بارگرام شود تخلف از شرایط قراردادی
            و قانونی و عرفی تلقی می گردد و بارگرام حق غیر فعال نمودن حساب کاربر
            و اقدام قانونی علیه وی را جهت مطالبه خسارت و احقاق حقوق قانونی خود
            خواهد داشت . ۳-۶:مسئولیت رعایت همۀ قوانین و مقررات راهنمایی و
            رانندگی در حین رانندگی و حفظ سلامت خودرو و بار توسط رانندگانی که در
            بارگرام فعالیت می کنند برعهدۀ راننده است . ۴-۶:کاربران و صاحبان کالا
            موظف هستند بار را در زمان اعلام شده آماده ارسال داشته باشد و مسئولیت
            هرگونه تاخیر در بارگیری یا تخلیه بر اساس بند ۴-۱۲ ماده ۴ همین قوانین
            و مقررات به عهده وی بوده و باید ضرر و زیان راننده را طبق آیین نامه
            پرداخت خسارات جبران نماید . ۵-۶:راننده متعهد می شود که در تمام زمان
            حمل بار با بارگرام موبایل خود را به صورت روشن و آنلاین (از لحاظ
            فیزیکی و از لحاظ اینترنتی) همراه داشته باشد و به تماس ها و پیام های
            بارگرام و فرستنده بار و تحویل گیرنده بار پاسخ صحیح دهد . ماده ۷ –
            شرایط اعلام بار ۱-۷:وسایلی که فرستنده قبل از ارسال باید اطلاع داده و
            مجوزهای لازم را اخذ نموده باشد عبارت است از مواد منفجره، محترقه،
            مواد سمی، اسیدی، بیماری زا و بد بو، مایعات و جامدات آتش زا و سوختی،
            مواد و وسایل رادیواکتیو و هر باری که نیاز به مجوز خاص منجمله کالاهای
            دامپزشکی و بهداشتی و ... داشته باشد . لازم به ذکر است راننده در هر
            مرحله از فرآیند اعلام تا تحویل بار در صورت اطلاع از ماهیت بارهای
            مذکور که احتیاج به مجوز از مراجع قانونی دارند و بار اعلامی فاقد آن
            مجوز باشد از حمل آن بار خودداری نموده و کلیه خسارات وارده بر عهده
            کاربران و صاحبان کالا می باشد. ۲-۷: کابران و صاحبان کالا بایستی در
            زمان اعلام بار نوع ناوگان را به درستی و متناسب با بار و ظرفیت آن
            اعلام نمایند. چنانچه در زمان مراجعه راننده مشخص گردد نوع ناوگان
            اعلامی با ظرفیت و ناوگان حواله شده یکسان نباشد بطوری که بارگیری میسر
            نباشد کاربران و صاحبان کالا مظابق قوانین بارگرام بایستی خسارت راننده
            را جبران نمایند. ۳-۷: انتقال بار و کالا بدون حضور صاحب بار یا
            نماینده ایشان در زمان بارگیری و تخلیه توسط راننده ممنوع است و کاربر
            حق ارسال کالا را نخواهد داشت. در صورت عدم رعایت، همه مسئولیت های
            ناشی از این تخلف برعهده اقدام کنندگان آن است و بارگرام حق دارد نسبت
            به قطع دسترسی اقدام و مبادرت به پیگیری قانونی از جمله مطالبه خسارت
            از شخص متخلف کند . 7-4 کاربران و صاحبان کالا متعهد میگردند که از
            متون و تصاویر مجرمانه در زمان اعلام بار استفاده نکنند و تمامی عواقب
            اطلاعات اعلام بار را خود می پذیرند. 7-5 کاربران و صاحبان کالا اقرار
            می نمایند که بار برای حمل دارند و سپس اعلام بار میکنند و در صورت جذب
            ناوگان مسئولیت عدم وجود بار و اطلاعات کذب بر عهده آنان است و بارگرام
            خسارت های بعدی را می تواند از آنها وصول نماید. ماده ۸ – موارد فنی
            هیچ یک از کاربران و رانندگان حق ندارد هیچ گونه تلاشی در جهت استخراج
            سورس کد (Source Code) نرم افزارهای بارگرام شامل دیکامپایل
            (Decompile) ، مهندسی معکوس(Reverse Engineering) یا فعالیت های مشابه
            انجام دهد، مگر اینکه اجازۀ چنین کاری به صورت قانونی صادر شده باشد.
            ۲-۸:کاربر مجاز نیست با استفاده از روش های Framing یاMirroring یا روش
            های دیگر نسخۀ دیگری از سامانه بارگرام را روی سرورهای دیگر ارائه کند.
            همچنین کاربر مجاز نیست در نرم افزار بارگرام یا در روش ارائه سامانه
            بارگرام تغییر یا اخلالی ایجاد کند. ۳-۸:کاربر حق ندارد برنامه یا
            اسکریپتی با هدف ایندکس گذاری(Indexing) ، مطالعه یا هر گونه فعالیت
            داده کاوی روی سرویس اجرا کند . ۴-۸:کاربر حق ندارد هیچ فعالیتی در
            راستای حصول دسترسی غیرقانونی و غیرمتداول به هیچ بخش از سامانه
            بارگرام یا سامانه مرتبط با بارگرام انجام دهد . 8-5 استفاده از
            اپلیکیشن های تغییر دهنده مکان در نسخه های موبایل توسط کابران و
            رانندگان ممنوع بوده و در صورت مشاهده این موضوع بارگرام میتواند
            راننده و کاربر را بصورت کامل از خدمات منع نماید. ماده ۹ – محتوای
            تولید شده توسط کاربران و رانندگان بارگرام در مقاطعی به کاربران اجازه
            می دهد که در وب سایت، برنامه موبایل و یا سایر بخش های این سامانه
            عکس، متن، فایل صوتی، فایل تصویری یا فایل های مشابه منتشر کنند.
            مالکیت هر مطلب (شامل متن، عکس، فایل صوتی، فایل تصویری و …)که به این
            شکل در سامانه ثبت شود همچنان متعلق به کاربران خواهد بود؛ اما با ثبت
            آنها در سامانه های مرتبط به بارگرام ،کاربران این حق را به بارگرام می
            دهند که آنها را در هر مکان و هر زمانی به صورت دیجیتال یا چاپی برای
            هر نوع کاربردی منتشر کند. تبصره: مسئولیت انتشار مطالب و تصاویر
            مجرمانه و سیاسی بر عهده کاربران و رانندگان می باشد. ماده ۱۰ – قطع
            سامانه بارگرام در شرایطی که به هر دلیل به این نتیجه برسد حضور یک
            کاربر (راننده یا صاحب کالا یا شرکت حمل و نقلی) می تواند برای شرکت یا
            سایر مشتریان یا راننده ها خطرناک یا نامطلوب باشد، حق حذف دسترسی
            کاربر مذکور را به سامانه بارگرام دارد . ماده ۱۱ – توافق از راه دور
            ۱-۱۱:کاربر توافق می کند جهت مبادلۀ آسان اطلاعات، همۀ تغییرات و
            الحاقیه های قوانین و مقررات حاضر اعم از تغییر و اضافه کردن شروط آن،
            ارسال اخطاریه و ابلاغیه های مربوط به بارگرام، از طریق سیستم رایانه
            ای بارگرام به عمل آید و کاربر ضمن پذیرش اطلاع از شروط و روند اجرایی
            آن موافقت خود را نسبت به اعمال شروط مذکور اعلام می کند .
            ۲-۱۱:مسئولیت حفظ و حراست از حساب کاربر برعهده کاربر بوده و ایشان ضمن
            پذیرش این مسئولیت، همه داده پیام های صادره از طریق حساب کاربری مذکور
            را منتسب به خود دانسته و هرگونه ادعایی نسبت به انکار، تردید و جعل
            داده پیام های ارسال شده از ناحیه نامبرده غیر قابل استماع و مردود است
            . ۳-۱۱:کاربر می پذیرد هر گونه رویه، اشکال، عبارات مبین تائید و اعلام
            قبولی و تصدیق داده پیام های صادره از طرف بارگرام به منزله امضا
            الکترونیکی و قبولی محسوب می شود و هر گونه ادعایی نسبت به عدم امضا و
            قبولی مذکور غیر قابل استماع و مردود است. ۱۱-۴:کاربر با عضویت در
            سامانه بارگرام قصد و اراده خود را نسبت به پذیرش انعقاد هرگونه اقدام
            و عمل حقوقی از جمله عقود و معاملات از راه دور و از طریق سیستم رایانه
            ای و الکترونیکی اعلام می کند. خلاصه توافق نامه راننده متعهد می گردد
            که کلیه قوانین و مقررات بارگرام را رعایت نماید و از نرم افزارهای
            مخرب و دستکاری اطلاعات و مشخصات تلفن همراه و مکان یابی و... استفاده
            نکند. همراه بودن موبایلی که توسط آن بار رزرو شده و حواله صادر گردیده
            است همراه راننده تا رسیدن به مقصد الزامی است و راننده در صورت داشتن
            حواله جاری بایسیتی تا رسیدن به مقصد مکان و اینترنت خود را روشن نگه
            دارد . راننده زمانی که یک اعلام بار را رزرو می نماید متعهد می گردد
            چنانچه اعلام بار به حواله تبدیل شود برای حمل اقدام می کند و درصورت
            باطل کردن حواله شامل جریمه و نمره منفی میگردد. راننده متعهد میگردد
            تنها در زمانی که ناوگان خالی در اختیار دارد اقدام به رزرو بارها
            میکند و در صورت اثبات خلاف این موضوع بارگام می تواند راننده را از
            خدمات خود منع و کلیه دسترسی های آن را قطع نماید. کاربران و صاحبان
            کالا متعهد میگردند که زمانی که بار آماده حمل دارند در سیستم اعلام
            بار نمایند. و در صورت تبدیل شدن اعلام بار به حواله و عدم وجود بار و
            یا کنسل کردن حواله ها دچار خسارت مالی و نمره منفی میگردند. صاحبان
            کالا و کاربران متعهد می گردند بدون تاخیر ناوگان مراجعه کرده را
            بارگیری و تخلیه نمایند و در صورت ایجاد تاخیر مطابق قوانین ملزم به
            پرداخت حق تاخیر می باشند راننده موظف است هنگام مراجعه به محل بارگیری
            در صورتیکه اعلام بار با واقعیت تفاوت داشت از بارگیری خودداری و به
            بارگرام گزارش دهد. راننده قبول می کند که به قوانین هر یک از پایانه
            ها پایبند است و هزینه های نوبت را در هر پایانه بصورت مجزا پرداخت
            نماید.
          </p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="(dialog2 = false), (rule2 = true)"
          >
            میپذیرم
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
  
  <script>
import gRecaptcha from "@finpo/vue2-recaptcha-invisible";
import axiosApi from "@/plugins/axios";
import Vue from "vue";
import { ConvertDateFromTo } from "@/plugins/convertDate";

import "../../assets/styles/register.css";

export default {
  name: "user",
  components: { gRecaptcha },
  data() {
    return {
      codeBox: false,
      loading: false,
      rules: {
        required: (v) => !!v || "اطلاعات را وارد کنید",
        numberic: (v) => (isNaN(v) ? "عدد وارد کنید" : !!v),
      },
      // user
      dialog1: false,
      dialog2: false,
      userForm: false,
      managerName: "",
      managerFamily: "",
      nationalId: "",
      mobile: "",
      provinceId: "",
      cityId: "",
      otp: "",
      birthDate: "",
      provinces: [],
      city: "",
      rule1: false,
      rule2: false,
    };
  },
  watch: {
    provinceId() {
      let code = this.provinces.filter((event) => {
        return event.id === this.provinceId;
      });
      axiosApi()
        .post("getCities", {
          code: code[0]["code"],
        })
        .then((result) => {
          this.city = result.data.data.city;
        });
    },
  },
  mounted() {
    this.getDetailRegister();
  },
  methods: {
    validate() {
      return true;
    },
    callback(token) {
      if (token) {
        this.registerUser();
      } else {
        console.log("nooo");
      }
    },
    getDetailRegister() {
      axiosApi()
        .get("registerDetail")
        .then(({ data }) => {
          this.provinces = data.data.provinces;
        });
    },
    sendOtp() {
      this.$refs.userForm.validate();
      if (this.userForm) {
        this.loading = true;
        axiosApi()
          .post("/v2/factory/registerPerson", {
            nationalId: this.nationalId,
            managerName: this.managerName,
            managerFamily: this.managerFamily,
            managerMobile: this.mobile,
            city: this.cityId,
            province: this.provinceId,
            otp: this.otp,
            birthDate: ConvertDateFromTo(this.birthDate),
          })
          .catch((e) => {
            const errors = Object.keys(e.response.data.errors);
            if (errors.length == 1 && errors[0] == "otp") {
              axiosApi()
                .post("v2/token/reSendCode", {
                  mobile: this.mobile,
                  type: "REGISTER",
                })
                .then(() => {
                  Vue.$toast.open({
                    message: "کد برای شما ارسال شد",
                    type: "success",
                  });
                  this.codeBox = true;
                })
                .catch((e) => {
                  if (e.response.status === 402) {
                    this.codeBox = true;
                    Vue.$toast.open({
                      message: "کد برای شما شده است",
                      type: "success",
                    });
                  }
                })
                .finally(() => (this.loading = false));
            }
          })
          .finally(() => (this.loading = false));
      }
    },
    registerUser() {
      if ((this.userForm, this.otp)) {
        this.loading = true;
        axiosApi()
          .post("/v2/factory/registerPerson", {
            nationalId: this.nationalId,
            managerName: this.managerName,
            managerFamily: this.managerFamily,
            managerMobile: this.mobile,
            city: this.cityId,
            province: this.provinceId,
            otp: this.otp,
            birthDate: ConvertDateFromTo(this.birthDate),
          })
          .then((r) => {
            this.setToken(r);
          })
          .catch(() => {
            // this.codeBox = false;
            // this.otp = "";
          })
          .finally(() => (this.loading = false));
      }
    },
    setToken(result) {
      this.$toast.open({
        message: "خوش آمدید",
        type: "success",
      });
      localStorage.setItem("role", "FACTORY");
      localStorage.setItem("mobile", this.mobile);
      localStorage.setItem("type", result.data.data.profile.factoryType);
      let name =
        result.data.data.profile.factoryName != null
          ? result.data.data.profile.factoryName
          : result.data.data.profile.managerName +
            " " +
            result.data.data.profile.managerFamily;
      localStorage.setItem("name", name);
      localStorage.setItem("token", result.data.data.token);
      localStorage.setItem("wallet", result.data.data.wallet);
      this.$parent.login = true;
      location.replace("/");
    },
  },
};
</script>
  
<style scoped>
.v-input--selection-controls {
  margin: 0 !important;
}
</style>
  